import { FC } from 'react'

import RFFFields from '../../react-final-form-fields'
import { validateRequired, validateMaxSymbols, composeValidators } from '../../../../util/validation'
import { nameofFactory, toOptions } from '../../../../util'

import {
  ISafetyCaseHazardMitigationFormFieldsProps,
  ISafetyCaseHazardMitigationValues,
} from './safety-case-hazard-mitigation-form-types'
import { useSafetyCaseHazardMitigationTypesQuery, useSafetyCaseHazardMitigationStatusesQuery } from '../../../../services'

const validateMaxSymbols2000 = validateMaxSymbols(2000, 'Description must not exceed 2000 characters')

const nameof = nameofFactory<ISafetyCaseHazardMitigationValues>()

const descriptionLabel = 'Description'
const mitigationTypeLabel = 'Mitigation Type'
const statusLabel = 'Status'

const SafetyCaseHazardMitigationFormFields: FC<ISafetyCaseHazardMitigationFormFieldsProps> = props => {
  const { disabled } = props

  const { data: mitigationTypes, isFetching: isMitigationTypesLoading } = useSafetyCaseHazardMitigationTypesQuery(
    undefined,
    undefined,
  )

  const { data: mitigationStatuses, isFetching: isMitigationStatusesLoading } = useSafetyCaseHazardMitigationStatusesQuery(
    undefined,
    undefined,
  )

  return (
    <>
      <RFFFields.Textarea
        name={nameof('description')}
        label={descriptionLabel}
        placeholder="Describe how this hazard is being mitigated"
        disabled={disabled}
        validate={composeValidators(validateRequired, validateMaxSymbols2000)}
      />

      <RFFFields.Select
        name={nameof('mitigationTypeId')}
        label={mitigationTypeLabel}
        placeholder={'Select ' + mitigationTypeLabel}
        disabled={disabled || isMitigationTypesLoading}
        options={toOptions(mitigationTypes)}
        validate={validateRequired}
      />

      <RFFFields.Select
        name={nameof('statusId')}
        label={statusLabel}
        placeholder={'Select ' + statusLabel}
        disabled={disabled || isMitigationStatusesLoading}
        options={toOptions(mitigationStatuses)}
        validate={validateRequired}
      />
    </>
  )
}

export default SafetyCaseHazardMitigationFormFields
